import { IDocumentFolderModel } from '@api/models';
import { LoadingButton } from '@components/buttons';
import { Button } from '@hyperflake/react-ui-library';
import { Drawer } from '@library/drawer';
import { FormHelperText, Label } from '@library/forms';
import { ErrorMessage, Form, Formik } from 'formik';
import useCreateFolderForm from 'modules/documents/hooks/useCreateFolderForm';
import { FormikInput } from 'modules/shared/features/formik';
import { toast } from 'react-toastify';

interface CreateFolderDrawerProps {
    clientId: string;
    parentFolderId: string;
    show: boolean;
    onClose: () => void;
    onAdd: (folder: IDocumentFolderModel) => void;
}

const CreateFolderDrawer = (props: CreateFolderDrawerProps) => {
    const { parentFolderId, show, onClose, onAdd, clientId } = props;

    const createFolderForm = useCreateFolderForm(clientId);

    const handleSubmit = async (values: Pick<IDocumentFolderModel, 'name'>) => {
        try {
            const payload = {
                ...values,
                parentId: parentFolderId || null,
            };

            const newFolder = await createFolderForm.submit(payload);

            onAdd(newFolder);
            onClose();

            toast.success('Folder added successfully.');
        } catch (err: any) {
            toast.error(err.data.message || 'Some error occurred, please try again.');
        }
    };

    return (
        <Drawer open={show} onClose={onClose}>
            <div className="flex flex-col h-[calc(100dvh-3rem)]">
                <h4>Add Folder</h4>

                <>
                    <div className="mt-6">
                        <Formik
                            initialValues={{
                                name: '',
                            }}
                            validationSchema={createFolderForm.schema}
                            enableReinitialize
                            onSubmit={handleSubmit}
                        >
                            <Form id="addFolderForm">
                                <div>
                                    <Label htmlFor="name">Name</Label>
                                    <FormikInput name="name" placeholder="Enter text here" />
                                    <FormHelperText variant={'error'}>
                                        <ErrorMessage name="name" />
                                    </FormHelperText>

                                    {/* <ErrorMessage component="div" className="form-error-message" name="name" /> */}
                                </div>
                            </Form>
                        </Formik>
                    </div>

                    <div className="mt-auto">
                        <div className="flex gap-4 mt-6">
                            <Button type="button" size="sm" color="secondary" className="" onClick={onClose}>
                                Cancel
                            </Button>

                            <LoadingButton
                                type="submit"
                                size="sm"
                                form="addFolderForm"
                                isLoading={createFolderForm.isLoading}
                                loadingText="Saving"
                            >
                                Save
                            </LoadingButton>
                        </div>
                    </div>
                </>
            </div>
        </Drawer>
    );
};

export default CreateFolderDrawer;
